
import React, { useState, useRef } from 'react';
import ModalWrapper from './ModalWrapper';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimePicker from 'react-time-picker';
import { BaseUrl } from '../../../Actions/Base';
import ReactSelect from "react-select"; // renamed to avoid conflict
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const AddClassWeeklySchedulePopup = ({
    showAddClassPopup,
    setShowOwnTimeFields,
    instructorTypeExtracted,
    InstructorState,
    setCombinedEvents,
    instituteClasses,
    studentScheduleEvents,
    setAddClassEvents,
    addClassEvents,
    CoursePackage,
    timeSlots,
    selectedDate,
    selectedDay,
    setSelectedDay,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    handleAddClass,
    error,
    setError,
    isSeparateSchedule,
    handleSeparateScheduleAddClass,
    setSelectedWeeklyScheduleDate,
    selectedWeeklyScheduleDate
}) => {
  const Days = [...new Set(timeSlots?.map(slot => slot.DayOfWeek))];
  console.log("Days in AddClassPopup is:",Days);
  console.log("selectedDate in add class is:",selectedDate)

  const reactSelectDayOptions = Days.map((day) => ({ label: day, value: day }));

  const typeToIndex = {
    Driving: 0,
    Online: 1,
    InClass: 2,
  };
 
  const idx = typeToIndex[instructorTypeExtracted] ?? 0;
  const chosenInstructor = InstructorState[idx] || {};
  console.log("chosenInstructor in add class is:",chosenInstructor)
  const instructorImgSrc = chosenInstructor.InstructorImage
    ? `${BaseUrl}/api/images/Instructors?url=${chosenInstructor.InstructorImage}`
    : null;

  const instructorFullName = chosenInstructor.InstructorName || "";

   // Function to handle date selection by the user
   const handleDateChange = (newValue) => {
    setSelectedWeeklyScheduleDate(newValue);
}; 

  
  return (
    <ModalWrapper isOpen={showAddClassPopup} onClose={() => setShowOwnTimeFields(false)}>
      <p className='text-[26px] text-[#4C34AD] font-semibold'>
        Custom Time Schedule ({instructorTypeExtracted})
      </p>

      <div className='mt-[10px] w-full rounded-[12px] p-[20px] flex gap-[20px] items-center' style={{ border: '1px solid #B7B7B7' }}>
        <img className="w-[55px] h-[55px] rounded-full" src={instructorImgSrc} alt="" />
        <p className="text-[23px]">{instructorFullName}</p>
      </div>

      <div className='mt-[10px] w-full rounded-[12px]' style={{ border: '1px solid #B7B7B7' }}>
        <div style={{ borderBottom: '1px solid #B7B7B7' }}>
          <div className='flex items-center gap-[5px] px-[15px] mt-[15px] mb-[10px]'>
            <AccessTimeIcon />
            <p className='text-[19px] text-[#333333] font-semibold'>Day And Time</p>
          </div>
        </div>
        <div className='flex flex-col py-[15px] px-[20px] gap-[15px]'>
          <div className='flex items-center gap-[70px]'>
            <p className='text-[19px] text-[#333333] font-semibold'>On</p>
            <div className='w-full'>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        value={selectedWeeklyScheduleDate}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params} style={{ height: '30px' }} />}
                    />
                </LocalizationProvider>
            </div>

          </div>

          <div className='flex items-center gap-[20px]'>
            <p className='text-[19px] text-[#333333] font-semibold'>From</p>
            <TimePicker
              onChange={setStartTime}
              value={startTime}
              disableClock
              clearIcon={null}
              format="h:mm a"
              className="custom-time-picker"
            />
          </div>

          <div className='flex items-center gap-[45px]'>
            <p className='text-[19px] text-[#333333] font-semibold'>To</p>
            <TimePicker
              onChange={setEndTime}
              value={endTime}
              disableClock
              clearIcon={null}
              format="h:mm a"
              className="custom-time-picker"
            />
          </div>

          {error && <p className="text-[#FF0000]">{error}</p>}

          <div className='mt-[10px] w-full flex justify-center items-center gap-[20px]'>
            <button
              type="button"
              className="rounded-[10px] w-[121px] h-[42px] text-[#4C34AD] text-[19px]"
              style={{ border: '2px solid #4C34AD' }}
              onClick={() => setShowOwnTimeFields(false)}
            >
              Cancel
            </button>

            <button
              type="button"
              className="rounded-[10px] bg-[#4C34AD] w-[121px] h-[42px] text-[19px] text-white"
              onClick={() => {
                isSeparateSchedule ? handleSeparateScheduleAddClass() : handleAddClass();
              }}
            >
              Add Class
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default AddClassWeeklySchedulePopup;